import { IUserStatusesConfig, TUserStatuses } from "./UserStatuses.t";

export const USER_STATUSES_NAMES = {
    FREE: 'free',
    STANDARD: 'standard',
    BRONZE: 'bronze',
    SILVER: 'silver',
    GOLD: 'gold',
    PLATINUM: 'platinum',
    ROYAL: 'royal',
} as const;

export const USER_STATUSES_STATES = {
    COMPLETED: 'completed',
    PLAN: 'plan',
    PROGRESS: 'progress',
} as const;

export const USER_STATUSES_CONFIG: {[status in TUserStatuses]: IUserStatusesConfig} = {
    [USER_STATUSES_NAMES.FREE]: {
        hideProgress: true
    },
    [USER_STATUSES_NAMES.STANDARD]: {
        carouselBackground: 'radial-gradient(30.19% 30.4% at 50.13% 50.13%, rgba(219, 162, 145, 0.06) 0%, rgba(219, 162, 145, 0.00) 100%)',
        congratulationsIconBackground: '#FFDFD2',
        glowingBackgroundColorDark: '#E57D508C',
        glowingBackgroundColorLight: '#E55C22',
        progressColor: '#DAA690',
    },
    [USER_STATUSES_NAMES.BRONZE]: {
        carouselBackground: 'radial-gradient(30.19% 30.4% at 50.13% 50.13%, rgba(219, 162, 145, 0.06) 0%, rgba(219, 162, 145, 0.00) 100%)',
        congratulationsIconBackground: '#FFDFD2',
        glowingBackgroundColorDark: '#E57D508C',
        glowingBackgroundColorLight: '#E55C22',
        progressColor: '#EAC09A',
    },
    [USER_STATUSES_NAMES.SILVER]: {
        carouselBackground: 'radial-gradient(31.19% 30.13% at 50.13% 50.13%, rgba(223, 227, 223, 0.10) 0%, rgba(223, 227, 223, 0.00) 100%)',
        congratulationsIconBackground: '#FFF3D2',
        glowingBackgroundColorDark: '#A7C2AF66',
        glowingBackgroundColorLight: '#5B665E',
        progressColor: '#9DA7A0',
    },
    [USER_STATUSES_NAMES.GOLD]: {
        carouselBackground: 'radial-gradient(31.59% 28.11% at 59.87% 54.53%, rgba(223, 200, 116, 0.05) 0%, rgba(223, 205, 140, 0.00) 100%), radial-gradient(28.2% 28.2% at 35.6% 43.2%, rgba(255, 246, 200, 0.06) 0%, rgba(255, 246, 200, 0.00) 100%)',
        congratulationsIconBackground: '#FFFDF8',
        glowingBackgroundColorDark: '#EBD17566',
        glowingBackgroundColorLight: '#E5C627',
        progressColor: '#E5D188',
    },
    [USER_STATUSES_NAMES.PLATINUM]: {
        carouselBackground: 'radial-gradient(28.48% 38.67% at 59.73% 50.13%, rgba(67, 150, 226, 0.09) 0%, rgba(67, 140, 226, 0.00) 100%), radial-gradient(29.07% 37.47% at 41.07% 50.13%, rgba(200, 242, 255, 0.08) 0%, rgba(98, 225, 242, 0.00) 100%)',
        congratulationsIconBackground: '#D2EFFF',
        glowingBackgroundColorDark: '#80DCFF66',
        glowingBackgroundColorLight: '#26BAF0',
        progressColor: '#8BD2ED',
    },
    [USER_STATUSES_NAMES.ROYAL]: {
        carouselBackground: 'radial-gradient(37.5% 50.91% at 58.53% 43.73%, rgba(118, 67, 226, 0.12) 0%, rgba(118, 67, 226, 0.00) 100%), radial-gradient(32.34% 25.04% at 32.4% 41.33%, rgba(138, 136, 222, 0.12) 0%, rgba(138, 136, 222, 0.00) 100%)',
        congratulationsIconBackground: '#E0D2FF',
        hideProgress: true,
    },
};
